import createNamespaceContext from './helper/createNamespaceContext';
export var PEOPLE_TEAMS_CONTEXT = 'peopleTeamsCtx';
export var PeopleTeamsAnalyticsContext = createNamespaceContext(PEOPLE_TEAMS_CONTEXT, 'PeopleTeamsAnalyticsContext');
//# sourceMappingURL=PeopleTeamsAnalyticsContext.js.map